import React from 'react';
import PropTypes from 'prop-types';
import cssModule from 'react-css-modules';

import style from 'newDesign/modules/common/components/oddsPanel/oddsPanelMarket/OddsPanelMarket.scss';

const MarketNameTemplate = ({ marketName }) => {
  const marketNameTemplateConfig = {
    '1x2': ['1', 'X', '2'],
    '12': ['1', '2'],
  };

  const cleanMarketName = marketName.replace(/\s+/g, '').toLowerCase();
  const config = marketNameTemplateConfig[cleanMarketName];

  if (!config) {
    return (
      <div styleName='odd-title' className='flex box-border fs-17 font-second justify-between'>
        <span>{marketName}</span>
      </div>
    );
  }

  const getPadding = (index, length) => {
    if (index === 0) {
      return '0 0 0 0.8vw';
    } else if (index === length - 1) {
      return '0 0.8vw 0 0';
    }

    return '0';
  };

  return (
    <div styleName='odd-title' className={`flex box-border fs-17 font-second ${config.length === 3 ? 'justify-between' : 'justify-around'}`}>
      {config.map((item, index) => (
        <div key={index} className='flex justify-center'>
          <div className='flex flex-col justify-center items-center' style={{ padding: getPadding(index, config.length) }}>
            {item}
          </div>
        </div>
      ))}
    </div>
  );
};

MarketNameTemplate.propTypes = {
  marketName: PropTypes.string.isRequired,
};

const MarketNameTemplateStyled = cssModule(MarketNameTemplate, style);
export default MarketNameTemplateStyled;
